import { jsx as _jsx } from "react/jsx-runtime";
import { BellRing, Captions, Clapperboard, Film, FlaskConical, LayoutDashboard, ListVideo, ScrollText, Scissors, SlidersHorizontal, } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { ContentOverviewPage } from './routes/overview.js';
import { ContentPublicationsPage } from './routes/publications.js';
import { ContentPublicationCardPage } from './routes/publication-card.js';
import { ContentClipsPage } from './routes/clips.js';
import { ContentClipCardPage } from './routes/clip-card.js';
import { ContentExperimentsPage } from './routes/experiments.js';
import { ContentCaptionsPage } from './routes/captions.js';
import { ContentRulesPage } from './routes/rules.js';
import { ContentAlertsPage } from './routes/alerts.js';
import { ContentDecisionsPage } from './routes/decisions.js';
import { ContentVideoSettingsPage } from './routes/video-settings.js';
// Fail-closed: модуль вне провайдера шелла показывает раздел только для чтения.
const { Provider: ContentModulePermsProvider, usePerms: useContentPerms } = createModulePerms({ canManage: false });
export { ContentModulePermsProvider, useContentPerms };
function OverviewRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentOverviewPage, { canManage: canManage });
}
function ClipsRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentClipsPage, { canManage: canManage });
}
function ClipCardRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentClipCardPage, { canManage: canManage });
}
function ExperimentsRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentExperimentsPage, { canManage: canManage });
}
function CaptionsRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentCaptionsPage, { canManage: canManage });
}
function RulesRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentRulesPage, { canManage: canManage });
}
function AlertsRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentAlertsPage, { canManage: canManage });
}
function VideoSettingsRoute() {
    const { canManage } = useContentPerms();
    return _jsx(ContentVideoSettingsPage, { canManage: canManage });
}
/**
 * Раздел «Контент» — управление публикациями роликов в соцсети через
 * шлюз admin-api `/api/content/*` к движку `wit_video_combine`.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`,
 * `ui-forms`), `admin-client-core` и `admin-contracts` — его можно поднять в
 * отдельной админке с `MODULES = [contentModule]` (см.
 * `docs/architecture/content-engine.md`).
 */
export const contentModule = {
    id: 'content',
    label: 'Контент',
    icon: Clapperboard,
    permission: 'content.read',
    workspace: 'content',
    order: 10,
    description: 'Публикации роликов в соцсети: охваты по аккаунтам и сетям, сила клипов, подписи и правила выбора.',
    showInNav: true,
    // Экраны — отдельные страницы бокового меню (а не вкладки навбара): под
    // пунктом модуля сразу идут его страницы. В пространстве «Контент» модулей
    // теперь несколько («Контент», «Соцсети»), у каждого — свои страницы под
    // своим пунктом. Карточка публикации своего пункта не имеет и подсвечивает
    // «Публикации».
    sectionsPlacement: 'sidebar',
    sections: [
        { path: '/', label: 'Обзор', icon: LayoutDashboard },
        { path: '/publications', label: 'Публикации', icon: ListVideo },
        { path: '/clips', label: 'Клипы', icon: Scissors },
        { path: '/decisions', label: 'Журнал решений', icon: ScrollText },
        { path: '/experiments', label: 'Эксперименты', icon: FlaskConical },
        { path: '/captions', label: 'Подписи', icon: Captions },
        { path: '/rules', label: 'Правила', icon: SlidersHorizontal },
        { path: '/video-settings', label: 'Длинные ролики и обложки', icon: Film },
        { path: '/alerts', label: 'Тревоги и отчёты', icon: BellRing },
    ],
    // Статические маршруты объявлены ДО `$id`.
    routes: [
        { path: '/', component: OverviewRoute },
        { path: '/publications', component: ContentPublicationsPage, label: 'Публикации' },
        { path: '/clips', component: ClipsRoute, label: 'Клипы' },
        { path: '/decisions', component: ContentDecisionsPage, label: 'Журнал решений' },
        { path: '/experiments', component: ExperimentsRoute, label: 'Эксперименты' },
        { path: '/captions', component: CaptionsRoute, label: 'Подписи' },
        { path: '/rules', component: RulesRoute, label: 'Правила' },
        {
            path: '/video-settings',
            component: VideoSettingsRoute,
            label: 'Длинные ролики и обложки',
        },
        { path: '/alerts', component: AlertsRoute, label: 'Тревоги и отчёты' },
        { path: '/publications/$id', component: ContentPublicationCardPage, label: 'Публикация' },
        { path: '/clips/$id', component: ClipCardRoute, label: 'Клип' },
    ],
};
export { ContentOverviewPage } from './routes/overview.js';
export { ContentPublicationsPage } from './routes/publications.js';
export { ContentPublicationCardPage } from './routes/publication-card.js';
export { ContentClipsPage } from './routes/clips.js';
export { ContentClipCardPage } from './routes/clip-card.js';
export { ContentExperimentsPage } from './routes/experiments.js';
export { ContentCaptionsPage } from './routes/captions.js';
export { ContentRulesPage } from './routes/rules.js';
export { ContentAlertsPage } from './routes/alerts.js';
export { ContentDecisionsPage } from './routes/decisions.js';
export { ContentVideoSettingsPage } from './routes/video-settings.js';
export { setContentApiBaseUrl, ContentRequestError } from './api.js';
//# sourceMappingURL=index.js.map